// extracted by mini-css-extract-plugin
module.exports =  {"warning":"tTAZ3oQeVM_SsIWdhu9S","description":"e_MSbOt9R1KsFhW5U4hS"};